import axiosInstance from '@/plugins/api/axiosInstance';
export default function consolTypes() {
    return {
        getConfigInfoPrepack,
        updateConfigInfoPrepack,
        getConfigInfoReceipt,
        updateConfigInfoReceipt,
        getConfigInfoAlert,
        updateConfigInfoAlert,
        getConfigInfoGuide,
        updateConfigInfoGuide,
        getConfigInfoWhrec,
        updateConfigInfoWhrec,
        getConfigInfoConsolidated,
        updateConfigInfoConsolidated,
        getConfigInfoPayment,
        updateConfigInfoPayment,
        getConfigInfoQuote,
        updateConfigInfoQuote,
        getConfigInfoBill,
        updateConfigInfoBill,
        getConfigInfoCustomer,
        updateConfigInfoCustomer,
        getConfigInfoTracking,
        updateConfigInfoTracking,
        getConfigInfoPickup,
        updateConfigInfoPickup,
        getConfigInfoMobile,
        updateConfigInfoMobile,
        getConfigInfoDeliveryList,
        updateConfigInfoDeliveryList,
        getConfigInfoAWB,
        updateConfigInfoAWB,
        getConfigInfoDash,
        updateConfigInfoDash,
        getConfigInfoPoboxDash,
        updateConfigInfoPoboxDash,
        getConfigInfoPobox,
        updateConfigInfoPobox,
        generateInfoPoboxDash
    };

    function getConfigInfoPrepack() {
        return axiosInstance.get(`/ui-prepack-setting/get`);
    }

    function updateConfigInfoPrepack(data) {
        return axiosInstance.patch(`/ui-prepack-setting/update`, data);
    }

    function getConfigInfoReceipt() {
        return axiosInstance.get(`/ui-receipt-setting/get`);
    }

    function updateConfigInfoReceipt(data) {
        return axiosInstance.patch(`/ui-receipt-setting/update`, data);
    }

    function getConfigInfoAlert() {
        return axiosInstance.get(`/ui-alert-setting/get`);
    }

    function updateConfigInfoAlert(data) {
        return axiosInstance.patch(`/ui-alert-setting/update`, data);
    }

    function getConfigInfoGuide() {
        return axiosInstance.get(`/ui-guide-setting/get`);
    }

    function updateConfigInfoGuide(data) {
        return axiosInstance.patch(`/ui-guide-setting/update`, data);
    }

    function getConfigInfoWhrec() {
        return axiosInstance.get(`/ui-whrec-setting/get`);
    }

    function updateConfigInfoWhrec(data) {
        return axiosInstance.patch(`/ui-whrec-setting/update`, data);
    }

    function getConfigInfoConsolidated() {
        return axiosInstance.get(`/ui-consolidated-setting/get`);
    }

    function updateConfigInfoConsolidated(data) {
        return axiosInstance.patch(`/ui-consolidated-setting/update`, data);
    }

    function getConfigInfoPayment() {
        return axiosInstance.get(`/ui-payment-setting/get`);
    }

    function updateConfigInfoPayment(data) {
        return axiosInstance.patch(`/ui-payment-setting/update`, data);
    }

    function getConfigInfoQuote() {
        return axiosInstance.get(`/ui-quote-setting/get`);
    }

    function updateConfigInfoQuote(data) {
        return axiosInstance.patch(`/ui-quote-setting/update`, data);
    }

    function getConfigInfoBill() {
        return axiosInstance.get(`/ui-bill-setting/get`);
    }

    function updateConfigInfoBill(data) {
        return axiosInstance.patch(`/ui-bill-setting/update`, data);
    }

    function getConfigInfoCustomer() {
        return axiosInstance.get(`/ui-customer-setting/get`);
    }

    function updateConfigInfoCustomer(data) {
        return axiosInstance.patch(`/ui-customer-setting/update`, data);
    }

    function getConfigInfoTracking() {
        return axiosInstance.get(`/ui-tracking-setting/get`);
    }

    function updateConfigInfoTracking(data) {
        return axiosInstance.patch(`/ui-tracking-setting/update`, data);
    }

    function getConfigInfoPickup() {
        return axiosInstance.get(`/ui-pickup-setting/get`);
    }

    function updateConfigInfoPickup(data) {
        return axiosInstance.patch(`/ui-pickup-setting/update`, data);
    }

    function getConfigInfoMobile() {
        return axiosInstance.get(`/ui-mobile-setting/get`);
    }

    function updateConfigInfoMobile(data) {
        return axiosInstance.patch(`/ui-mobile-setting/update`, data);
    }

    function getConfigInfoDeliveryList() {
        return axiosInstance.get(`/ui-delivery-list-setting/get`);
    }

    function updateConfigInfoDeliveryList(data) {
        return axiosInstance.patch(`/ui-delivery-list-setting/update`, data);
    }

    function getConfigInfoAWB() {
        return axiosInstance.get(`/ui-awb-setting/get`);
    }

    function updateConfigInfoAWB(data) {
        return axiosInstance.patch(`/ui-awb-setting/update`, data);
    }

    function getConfigInfoDash() {
        return axiosInstance.get(`/ui-dash-setting/get`);
    }

    function updateConfigInfoDash(data) {
        return axiosInstance.patch(`/ui-dash-setting/update`, data);
    }

    function getConfigInfoPoboxDash() {
        return axiosInstance.get(`/ui-dash-setting/pobox/get`);
    }

    function updateConfigInfoPoboxDash(data) {
        return axiosInstance.patch(`/ui-dash-setting/pobox/update`, data);
    }

    function getConfigInfoPobox() {
        return axiosInstance.get(`/ui-pobox-setting/get`);
    }

    function updateConfigInfoPobox(data) {
        return axiosInstance.patch(`/ui-pobox-setting/update`, data);
    }

    function generateInfoPoboxDash() {
        return axiosInstance.get(`/ui-dash-setting/pobox/generate`);
    }
}
